<pbc-filter [config]="UmkreissucheFilterConfig" [filter]="umkreissuche.filter$ | async" (filterChange)="umkreissuche.filter$.next($event)"></pbc-filter>
